import { render, staticRenderFns } from "./ProofReceiptImageLocationView.vue?vue&type=template&id=17c6bc8c"
import script from "./ProofReceiptImageLocationView.vue?vue&type=script&lang=js"
export * from "./ProofReceiptImageLocationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports